import { Event } from '../Event'
import { Identity } from '../../constants'

export interface CuratedItemRemovedEventProperties {
  curated_item_id: string
  removal_reason: string | null
  custom_reason: string | null
}

export class CuratedItemRemovedEvent extends Event<CuratedItemRemovedEventProperties> {
  static displayName = 'Curated Item Removed'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
